<div class="container my-4">
  <div class="row">
    <div class="col-12">
      <span class="title_header_bar">Sales Target Setup</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="table-responsive mt-2 mb-4">
      <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
        <ng-container matColumnDef="salesUserName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="salesUserName">Sales User</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.salesUserName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="providerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="providerName">Service Provider</mat-header-cell>
          <mat-cell *matCellDef="let dataField; let i = index">
            <p class="text-truncate txtalign">{{dataField.providerName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <div class="text-truncate text-center">
              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                (click)="gotoSalesTargetHC(dataField.userId,1)"></i>

              <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-eye mr-3"
                (click)="gotoSalesTargetHC(dataField.userId,2)"></i>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
      </mat-table>
    </div>
    <div class="table_pagenation">
      <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
        [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>